import Image from "next/image";
import Link from "next/link";
import React from "react";
import Button from "../components/Micro/Button";

const NotFound = () => {
  return (
    <main className="h-screen w-full bg-light dark:bg-theme-color">
      <div className=" container w-full h-full flex flex-col items-center justify-around">
        <Image
          alt="404 image"
          width={550}
          height={220}
          src={
            "https://res.cloudinary.com/dgqfojhx4/image/upload/v1708776317/dashboard-assets/404_vwjb7j.png"
          }
        />
        <h1 className="text-5xl font-semibold text-primary-dark dark:text-white text-center ">
          You seem lost
        </h1>
        <span className="w-full md:w-1/2 text-center">
          What you are in search for doesn’t exist or has been moved from this
          domain. Don’t fret click the button below to get back to safety
        </span>
        <Link href={"/"}>
          <Button>Back to Safety</Button>
        </Link>
      </div>
    </main>
  );
};

export default NotFound;
